export class InvalidOperationError extends Error {
    readonly name: string = "InvalidOperationError";

    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
